__turbopack_context__.v({
  "error": "Select-module-scss-module__xWDs_G__error",
  "fade-in": "Select-module-scss-module__xWDs_G__fade-in",
  "icon": "Select-module-scss-module__xWDs_G__icon",
  "no-transform": "Select-module-scss-module__xWDs_G__no-transform",
  "rotate": "Select-module-scss-module__xWDs_G__rotate",
  "select": "Select-module-scss-module__xWDs_G__select",
  "success": "Select-module-scss-module__xWDs_G__success",
  "wrapper": "Select-module-scss-module__xWDs_G__wrapper",
});
